
<script>
import { parseSchema } from '@tencent/gems-renderer-core';
import { initComponentInstanceIndexMap } from '@tencent/gems-shared';
import AppRender  from './handlers/vueHandlers/render.vue';


export default {
  props: ['schema','materials','global','meta','autoParseStyle'],
  mounted() {},
  render(createElement){
    const { componentInstances, pluginInstances } = parseSchema(this.schema, this.materials, {
      autoParseStyle: this.autoParseStyle,
    });
    // Init
    initComponentInstanceIndexMap(componentInstances);

    return createElement(
      AppRender,
      {
        props: {
          componentInstances: componentInstances,
          pluginInstances: pluginInstances,
          global: this.global,
          meta: this.meta,
        },
      },
    );
  }
}
</script>



